import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=95d0ea2a&scoped=true"
import script from "./GenericCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GenericCard.vue?vue&type=style&index=0&id=95d0ea2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d0ea2a",
  null
  
)

export default component.exports